import React from 'react';

export default function DollarSign({ className = '', title }) {
  return (

    <svg
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      className={className}
    >
      <path
        d="M16.1351 4.82004L15.0389 6.22827C17.4018 8.06686 18.5804 11.0435 18.1152 13.9974C17.7744 16.1649 16.6098 18.07 14.836 19.362C13.0617 20.6533 10.8912 21.1782 8.72371 20.8357C4.24925 20.1312 1.18126 15.9178 1.88461 11.443C2.22538 9.27528 3.3904 7.37008 5.16438 6.07841C6.71321 4.95091 8.564 4.40938 10.4514 4.5168L8.90876 6.13516L10.0531 7.22725L12.4883 4.67076L12.4888 4.6717L13.5798 3.52615L12.4362 2.43523L12.4356 2.43559L9.88006 0L8.78833 1.14556L10.4535 2.73156C8.18993 2.6245 5.97281 3.28294 4.11428 4.63617C1.95509 6.20834 0.537358 8.52713 0.122241 11.166C-0.734025 16.6124 2.99991 21.7414 8.44627 22.5985C8.97267 22.6815 9.49883 22.7222 10.0216 22.7222C12.1195 22.7222 14.1579 22.0629 15.8861 20.8043C18.0455 19.2319 19.463 16.9131 19.8782 14.2747C20.4444 10.6801 19.01 7.0571 16.1351 4.82004Z"
        fill="currentColor"
      />
      <path
        d="M10.9798 17.8208V17.8204L10.9799 16.7935C12.1974 16.6576 13.382 15.8885 13.382 14.4283C13.382 12.4443 11.5372 12.2168 10.1897 12.0509C9.32821 11.9479 8.66883 11.8284 8.66883 11.3065C8.66883 10.5809 9.69161 10.5027 10.1315 10.5027C10.7843 10.5027 11.4808 10.8095 11.7175 11.2012L11.7862 11.3151L13.1397 10.6888L13.0727 10.5523C12.5683 9.52115 11.6645 9.22283 10.9795 9.1024V8.19829H9.3947V9.09853C7.91927 9.31617 7.04307 10.135 7.04307 11.3065C7.04307 13.2167 8.77753 13.4106 10.0429 13.5525C11.1707 13.6854 11.6957 13.9641 11.6957 14.4283C11.6957 15.3152 10.4674 15.3845 10.0909 15.3845C9.25281 15.3845 8.44474 14.9663 8.21103 14.4111L8.15298 14.274L6.6826 14.8974L6.74123 15.0345C7.17664 16.0536 8.11616 16.6922 9.39493 16.8433V17.8208H10.9798Z"
        fill="currentColor"
      />
    </svg>


  );
}

